import ServerSearchFieldWithTags from './ServerSearchFieldWithTags';

export default ServerSearchFieldWithTags;
